import { Component, Ref } from 'vue-property-decorator'
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader.vue'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import { AgGridOptions, AgGridRowModelType } from '@/shared/models/ag-grid.model'
import {
    GetContextMenuItemsParams,
    GridReadyEvent,
    MenuItemDef,
    SelectionChangedEvent
} from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import AssignmentsModal from '@/modules/configurationModule/detail/vitrolink/assignments/components/assignments-modal/assignments-modal.vue'
import { BaseCrud } from '@/shared/models/cruds.models'
import BaseCrudServerSideComponent from '@/shared/resources/base-crud-server-side.component'

@Component({
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        AssignmentsModal
    }
})
export default class AssignmentsGrid extends BaseCrudServerSideComponent<any> implements BaseCrud {
    @Ref() readonly assignmentsModal!: any

    private actionTitle !: string
    private selectedRows !: Array<object>
    private rowData!: Array<object>
    private columnDefs!: Array<object>
    private gridApi !: any

    constructor() {
        super()
        this.actionTitle = ''
        this.selectedRows = []
        this.columnDefs = [
            { type: 'customCheckbox' },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.assignmentElement'),
                colId: 'assignmentElement',
                field: 'assignmentElement',
                minWidth: 250,
                flex: 1,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.assignmentName'),
                colId: 'assignmentName',
                field: 'assignmentName',
                minWidth: 150,
                flex: 1,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.assignmentCode'),
                colId: 'assignmentCode',
                field: 'assignmentCode',
                minWidth: 150,
                flex: 1,
                filter: true,
                sortable: false
            },
            // TODO: Please check Analysis Documentation to know when show/hide next column
            {
                type: 'text',
                headerName: i18n.tc('configuration.grid.device', 1),
                colId: 'device',
                field: 'device',
                minWidth: 150,
                flex: 1,
                filter: true,
                sortable: false
            }
            // TODO: Please check Analysis Documentation to know when show/hide next column
            /* {
                type: 'text',
                headerName: i18n.t('configuration.grid.externalSystem'),
                colId: 'externalSystem',
                field: 'externalSystem',
                minWidth: 150,
                flex: 1,
                filter: true,
                sortable: false
            } */
        ]
        this.rowData = [
            {
                assignmentElement: 'Elemento 1',
                assignmentName: 'Nombre asignado 1',
                assignmentCode: '2437',
                device: 'Dispositivo 1'
            },
            {
                assignmentElement: 'Elemento 2',
                assignmentName: 'Nombre asignado 2',
                assignmentCode: '2438',
                device: 'Dispositivo 2'
            },
            {
                assignmentElement: 'Elemento 3',
                assignmentName: 'Nombre asignado 3',
                assignmentCode: '2438',
                device: 'Dispositivo 3'
            }
        ]
        this.gridApi = null
    }

    get gridOptions(): AgGridOptions {
        return {
            sideBar: gridSideBarConfig,
            rowModelType: AgGridRowModelType.CLIENT_SIDE,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: this.onGridReady,
            onSelectionChanged: this.onSelectionChanged,
            getRowHeight: () => this.rowHeight
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            return [
                {
                    name: this.$t('configuration.actions.update').toString()
                },
                {
                    name: this.$t('configuration.actions.delete').toString()
                },
                {
                    name: this.$t('configuration.actions.activate').toString()
                },
                {
                    name: this.$t('configuration.actions.deactivate').toString()
                }
            ]
        }
    }

    onSelectionChanged({ api }: SelectionChangedEvent) {
        this.selectedRows = api.getSelectedRows()
    }

    onGridReady(event: GridReadyEvent): void {
        this.state.gridApi = event.api
        this.state.columnApi = event.columnApi
    }

    showAssignmentsModal(title: string) {
        this.actionTitle = title
        this.assignmentsModal.show()
    }

    // TODO: Mejorar esto en Front
    async deleteAssignments() {
        await this.$_showConfirmationModal(`${this.$t('configuration.grid.deleteConfirmation')} ${this.selectedRows.length} ${this.$tc('configuration.grid.element', this.selectedRows.length)}, <br/> ${this.$t('configuration.grid.deleteQuestion')}`, this.$t('configuration.actions.delete').toString())
    }
}
